module.exports = __webpack_public_path__ + "static/media/rain_hi.9d11da06.svg";